$shm_hitalama_app $mol_view
	title \Hitalama
	maps_list_visible? true
	projects_list_visible? true
	chat_width? 432
	plugins /
		<= Theme $mol_theme_auto
	auto /
		^
		<= master_link
		<= entergate_pending_auto null
		<= mcp_client_auto null
		<= side_views_auto null
		<= selfhosted_tauri_admin_auto null
		<= command_palette_keydown_listener $shm_listener /
			\keydown
			<= command_palette_keydown_handler null
			<= document null
			* passive false
	Baza_status $giper_baza_status
		master_link => master_link
	sub /
		<= Book
		<= Command_palette $shm_hitalama_map_command_palette
			opened? <=> command_palette_opened? false
		<= Right_bottom_panel $mol_view
			sub /
				<= Process_monitor_toggle $mol_check_icon
					hint \Process monitor
					Icon <= Process_monitor_toggle_icon $mol_icon_clock_fast
					checked? <=> process_monitor_opened? false
				<= Speech $shm_hitalama_speech
				<= Mbutton $shm_hitalama_mbutton
					checked? <=> chat_opened? false
		<= Fullscreen $shm_hitalama_app_fullscreen
			map_book <= Map
			overlay_panel <= Overlay_panel
		<= Overlay_panel $shm_hitalama_app_overlay
	Book $shm_hitalama_app_book
		maps_list_visible? <=> maps_list_visible?
		projects_list_visible? <=> projects_list_visible?
		param \section
		menu_title \Hitalama
		menu_tools /
			<= Status $giper_baza_status
			<= Lights $mol_lights_toggle
		menu_foot /
			<= Footer $shm_hitalama_footer
				version <= version_data_version \-
				date <= version_data_date \-
		placeholders /
		Menu => Book_menu
		spread => spread
		Spread* => Spread*
		Spread_default => Spread_default
		pages <= book_pages /
			<= Book_menu
			<= Main $mol_page
				head /
					<= Tokens $mol_view
						sub /
							<= Tokens_label $mol_text
								text \Сбор осуществляется от имени
							<= Token_switch $shm_hitalama_vk_token_switch
								current => token
					<= Profile $shm_hitalama_profile_switch
				body / <= Spread_current $mol_view
			^ side_views /
		spreads *
			\
				<= Analysis $shm_hitalama_vk_analysis
					token <= token
			lists <= Lists $shm_hitalama_vk_lists
				token <= token
			projects <= Projects $shm_projects_catalog
				projects_list_visible? <=> projects_list_visible?
			duckdb_page <= Duckdb $shm_hitalama_duckdb_page
			maps <= Maps $shm_hitalama_map_catalog
				maps_list_visible? <=> maps_list_visible?
			docs <= Docs $shm_hitalama_docs
			tasks <= Tasks $shm_hitalama_tasks
			tests <= Tests $shm_tests_app
			benchmarks <= Benchmarks $shm_hitalama_benchmarks_catalog
			settings <= Settings $shm_hitalama_settings
			profile <= Profile_page $shm_hitalama_profile_page
				profiles <= profiles
	Internal_register $shm_hitalama_entergate_internal
		pending_login? <=> entergate_pending_login? \
	Enter $shm_hitalama_profile_enter
		profiles <= profiles $shm_hitalama_profile_dict
	Register $shm_hitalama_profile_register
		profiles <= profiles
	no_auth_pages *
		domain_page <= Domain_page $shm_hitalama_domain_page
	Map $shm_hitalama_map_book - \from Maps
	-
		entity <= map $shm_hitalama_map
	Ext $shm_hitalama_extension_app
	Map_chat $shm_hitalama_opencode_map_chat
		width? <=> chat_width?
	Project_chat $shm_hitalama_project_codex
		width? <=> chat_width?
	Process_monitor $shm_hitalama_process_monitor_maps
